import { createAction, handleActions } from 'redux-actions';
import { takeLatest, put, select } from 'redux-saga/effects';
import produce from 'immer';
import * as shampooAPI from '../lib/api/shampoo';
import { setAuthorization } from '../lib/api/account';
import createRequestSaga, {
  createRequestActionTypes,
} from '../lib/createRequestSaga';
// import shampooDemo from './initialValues/shampoo.demo';
import { getUsers } from './user';
import { getScalpType } from './scalp';

//====================== Action Type 정의 ======================//
const [GET_SHAMPOO_LIST, GET_SHAMPOO_LIST_SUCCESS, GET_SHAMPOO_LIST_FAILURE] =
  createRequestActionTypes('shampoo/GET_SHAMPOO_LIST');
const CHANGE_SEARCH_QUERY = 'shampoo/CHANGE_SEARCH_QUERY';
const SET_SELECTED_SHAMPOO_ID = 'shampoo/SET_SELECTED_SHAMPOO_ID';
const SET_SEARCH_TYPE = 'shampoo/SET_SEARCH_TYPE';
const SET_RESULT_TYPE = 'shampoo/SET_RESULT_TYPE';
const CHANGE_USER_CONDITION = 'shampoo/CHANGE_USER_CONDITION';
const INIT_USER_CONDITION = 'shampoo/INIT_USER_CONDITION';
const INIT_USER_CONDITIONS = 'shampoo/INIT_USER_CONDITIONS';
const [
  PUT_USER_CONDITIONS,
  PUT_USER_CONDITIONS_SUCCESS,
  PUT_USER_CONDITIONS_FAILURE,
] = createRequestActionTypes('shampoo/PUT_USER_CONDITIONS');
const [
  POST_TEMPORARY_USER_CONDITIONS,
  POST_TEMPORARY_USER_CONDITIONS_SUCCESS,
  POST_TEMPORARY_USER_CONDITIONS_FAILURE,
] = createRequestActionTypes('shampoo/POST_TEMPORARY_USER_CONDITIONS');
const [
  POST_TEMPORARY_USER_AUTH,
  POST_TEMPORARY_USER_AUTH_SUCCESS,
  POST_TEMPORARY_USER_AUTH_FAILURE,
] = createRequestActionTypes('shampoo/POST_TEMPORARY_USER_AUTH');
const [
  POST_SHAMPOO_RESULT,
  POST_SHAMPOO_RESULT_SUCCESS,
  POST_SHAMPOO_RESULT_FAILURE,
] = createRequestActionTypes('shampoo/POST_SHAMPOO_RESULT');
const [
  GET_SHAMPOO_INGREDIENTS,
  GET_SHAMPOO_INGREDIENTS_SUCCESS,
  GET_SHAMPOO_INGREDIENTS_FAILURE,
] = createRequestActionTypes('shampoo/GET_SHAMPOO_INGREDIENTS');
const CHANGE_REGISTER_FORM = 'shampoo/CHANGE_REGISTER_FORM';
const INIT_REGISTER_FORM = 'shampoo/INIT_REGISTER_FORM';
const [
  POST_SHAMPOO_REGISTER,
  POST_SHAMPOO_REGISTER_SUCCESS,
  POST_SHAMPOO_REGISTER_FAILURE,
] = createRequestActionTypes('shampoo/POST_SHAMPOO_REGISTER');
const [
  GET_SHAMPOO_HISTORIES,
  GET_SHAMPOO_HISTORIES_SUCCESS,
  GET_SHAMPOO_HISTORIES_FAILURE,
] = createRequestActionTypes('shampoo/GET_SHAMPOO_HISTORIES');
const SET_SHAMPOO_RESULT_FROM_HISTORY =
  'shampoo/SET_SHAMPOO_RESULT_FROM_HISTORY';

export const [
  GET_TOP_RANKED_SHAMPOO_LIST,
  GET_TOP_RANKED_SHAMPOO_LIST_SUCCESS,
  GET_TOP_RANKED_SHAMPOO_LIST_FAILURE,
] = createRequestActionTypes('shampoo/GET_TOP_RANKED_SHAMPOO_LIST');

//====================== SUCCESS 핸들러 ======================//
function* handlePutUserConditionsSuccess() {
  // 두피문진 후 다음버튼 클릭 시 pustUserConditiont 성공시
  const {
    access_token,
    user_id,
    shampoo_id,
    language,
    shampooList,
    userConditions,
    searchType,
    resultType,
    diagnosis_items,
  } = yield select(({ account, user, shampoo, status, scalp }) => ({
    access_token: account.account.access_token,
    user_id: user.users[0].user_id,
    shampoo_id: shampoo.selectedShampooId,
    language: status.language,
    shampooList: shampoo.shampooList.response,
    userConditions: shampoo.userConditions,
    searchType: shampoo.searchType,
    resultType: shampoo.resultType,
    diagnosis_items: scalp.diagnosis_items,
  }));

  // 220311 : 두피진단 + 문진 기반으로 두피타입과 두피고민 뽑아내기
  if (resultType === 'withScalp' && diagnosis_items) {
    yield put(
      getScalpType({
        user_id: user_id,
        diagnosis_items: diagnosis_items?.diagnosis_items,
      }),
    );
  }

  // topRanked 검색이 아닌 경우 선택된 샴푸와의 매칭도 분석 진행
  if (shampoo_id && searchType?.type !== 'topRanked')
    yield put(
      postShampooResult({
        user_id: user_id,
        product_id: shampoo_id,
        diagnosis_items:
          resultType === 'withScalp' && diagnosis_items
            ? diagnosis_items?.diagnosis_items
            : null,
      }),
    );

  yield put(
    getTopRankedShampooList({
      user_id: user_id,
      diagnosis_items:
        resultType === 'withScalp' && diagnosis_items
          ? diagnosis_items?.diagnosis_items
          : null,
    }),
  );

  yield put(getUsers(access_token));

  if (window.dataLayer) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: { step: 2 },
          products: [
            {
              name: shampooList[shampoo_id].name[`${language}`],
              id: shampoo_id,
              price: '1',
              brand: shampooList[shampoo_id].brand[`${language}`],
              category: 'Shampoo',
              quantity: 1,
            },
          ],
        },
      },
      gender: userConditions.gender,
      age: userConditions.age_group,
      scalpType: userConditions.scalp_type,
      hairLoss: userConditions.hair_loss_type === 'NONE' ? false : true,
    });
  }
}

function* handlePostTemporaryUserConditionsSuccess() {
  const {
    auth_key,
    auth_secret,
    shampoo_id,
    language,
    shampooList,
    userConditions,
  } = yield select(({ shampoo, status }) => ({
    auth_key: shampoo.postTemporaryUserConditionsResult.response.auth_key,
    auth_secret: shampoo.postTemporaryUserConditionsResult.response.auth_secret,
    shampoo_id: shampoo.selectedShampooId,
    language: status.language,
    shampooList: shampoo.shampooList.response,
    userConditions: shampoo.userConditions,
  }));
  yield put(postTemporaryUserAuth({ data: { auth_key, auth_secret } }));
  sessionStorage.setItem(
    'temporary_auth',
    JSON.stringify({ auth_key, auth_secret }),
  );

  if (window.dataLayer) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: { step: 2 },
          products: [
            {
              name: shampoo_id
                ? shampooList[shampoo_id].name[`${language}`]
                : 'topRanked',
              id: shampoo_id ? shampoo_id : 'topRanked',
              price: '1',
              brand: shampoo_id
                ? shampooList[shampoo_id].brand[`${language}`]
                : 'topRanked',
              category: 'Shampoo',
              quantity: 1,
            },
          ],
        },
      },
      gender: userConditions.gender,
      age: userConditions.age_group,
      scalpType: userConditions.scalp_type,
      hairLoss: userConditions.hair_loss_type === 'NONE' ? false : true,
    });
  }
}

function* handlePostTemporaryUserAuthSuccess() {
  const {
    access_token,
    user_id,
    product_id,
    searchType,
    resultType,
    diagnosis_items,
  } = yield select(({ shampoo, scalp }) => ({
    access_token: shampoo.postTemporaryUserAuthResult.response.access_token,
    user_id: shampoo.postTemporaryUserAuthResult.response.user_id,
    product_id: shampoo.selectedShampooId,
    searchType: shampoo.searchType,
    resultType: shampoo.resultType,
    diagnosis_items: scalp.diagnosis_items,
  }));
  setAuthorization(access_token);

  if (product_id && searchType?.type !== 'topRanked') {
    let diagnosis_items =
      resultType === 'withScalp' && diagnosis_items
        ? diagnosis_items?.diagnosis_items
        : null;
    yield put(postShampooResult({ user_id, product_id, diagnosis_items }));
  }
  yield put(
    getTopRankedShampooList({
      user_id: user_id,
      diagnosis_items:
        resultType === 'withScalp' && diagnosis_items
          ? diagnosis_items?.diagnosis_items
          : null,
    }),
  );
}

function* handlePostShampooResultSuccess() {
  const {
    shampooList,
    analysisId,
    shampooId,
    language,
    user_id,
    temporary_user_id,
  } = yield select(({ shampoo, status, user }) => ({
    shampooList: shampoo.shampooList.response,
    analysisId: shampoo.shampooResult.response.analysis_id,
    shampooId: shampoo.selectedShampooId,
    language: status.language,
    user_id: user.users ? user.users[0].user_id : null,
    temporary_user_id: shampoo.postTemporaryUserAuthResult.response?.user_id,
  }));

  yield put(
    getShampooIngredients({
      user_id: user_id || temporary_user_id,
      analysis_id: analysisId,
    }),
  );

  if (window.dataLayer) {
    window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        purchase: {
          actionField: {
            id: analysisId, // Transaction ID. Required for purchases and refunds.
            affiliation: 'Shampoo Analysis',
            revenue: '1', // Total transaction value (incl. tax and shipping)
          },
          products: [
            {
              name: shampooList[shampooId].name[`${language}`],
              id: shampooId,
              price: '1',
              brand: shampooList[shampooId].brand[`${language}`],
              category: 'Shampoo',
              quantity: 1,
            },
          ],
        },
      },
    });
  }
}
// 여기
function* handleGetTopRankedShampooListSuccess() {
  const {
    user_id,
    temporary_user_id,
    product_id,
    topRankedShampooList,
    searchType,
    resultType,
    diagnosis_items,
  } = yield select(({ shampoo, user, scalp }) => ({
    user_id: user.users ? user.users[0].user_id : null,
    temporary_user_id: shampoo.postTemporaryUserAuthResult.response?.user_id,
    product_id: shampoo.selectedShampooId,
    topRankedShampooList: shampoo.topRankedShampooList,
    searchType: shampoo.searchType,
    resultType: shampoo.resultType,
    diagnosis_items: scalp.diagnosis_items,
  }));
  if (product_id && searchType?.type !== 'topRanked') return;
  else {
    yield put(setSearchType({ type: 'topRanked' }));
    // RANDOM index
    const length = topRankedShampooList.response.length;
    const idx = Math.floor((Math.random() * length) % length);
    let topRankedShampooId = topRankedShampooList.response[idx].product.id;
    yield put(setSelectedShampooId(topRankedShampooId));
    yield put(
      postShampooResult({
        user_id: user_id || temporary_user_id,
        product_id: topRankedShampooId,
        diagnosis_items:
          resultType === 'withScalp' && diagnosis_items
            ? diagnosis_items?.diagnosis_items
            : null,
      }),
    );
  }
}
//====================== Action 생성 ======================//
export const getShampooList = createAction(GET_SHAMPOO_LIST);

export const changeSearchQuery = createAction(
  CHANGE_SEARCH_QUERY,
  (value) => value,
);

export const changeUserCondition = createAction(
  CHANGE_USER_CONDITION,
  ({ key, childKey = null, value = null }) => ({
    key,
    childKey,
    value,
  }),
);

export const setSelectedShampooId = createAction(
  SET_SELECTED_SHAMPOO_ID,
  (shampooId) => shampooId,
);
export const setSearchType = createAction(SET_SEARCH_TYPE, (type) => type);
export const setResultType = createAction(SET_RESULT_TYPE, (type) => type);

export const initUserCondition = createAction(
  INIT_USER_CONDITION,
  ({ key, childKey = null }) => ({ key, childKey: childKey }),
);

export const initUserConditions = createAction(INIT_USER_CONDITIONS);

export const putUserConditions = createAction(
  PUT_USER_CONDITIONS,
  ({ data, user_id }) => ({ data, user_id }),
);

export const postTemporaryUserConditions = createAction(
  POST_TEMPORARY_USER_CONDITIONS,
  ({ data }) => ({ data }),
);

export const postTemporaryUserAuth = createAction(
  POST_TEMPORARY_USER_AUTH,
  ({ data }) => ({ data }),
);

export const postShampooResult = createAction(
  POST_SHAMPOO_RESULT,
  ({ user_id, product_id, diagnosis_items }) => ({
    user_id,
    product_id,
    diagnosis_items,
  }),
);

export const getShampooIngredients = createAction(
  GET_SHAMPOO_INGREDIENTS,
  ({ user_id, analysis_id }) => ({ user_id, analysis_id }),
);

export const changeRegisterForm = createAction(
  CHANGE_REGISTER_FORM,
  ({ key, value }) => ({
    key,
    value,
  }),
);

export const initRegisterForm = createAction(INIT_REGISTER_FORM);

export const postShampooRegister = createAction(
  POST_SHAMPOO_REGISTER,
  ({ type, data }) => ({ type, data }),
);

export const getShampooHistories = createAction(
  GET_SHAMPOO_HISTORIES,
  ({ user_id }) => ({ user_id }),
);

export const setShampooResultFromHistory = createAction(
  SET_SHAMPOO_RESULT_FROM_HISTORY,
  (result) => result,
);

export const getTopRankedShampooList = createAction(
  GET_TOP_RANKED_SHAMPOO_LIST,
  ({ user_id, diagnosis_items }) => ({ user_id, diagnosis_items }),
);

//====================== saga 생성 ======================//
export const getShampooListSaga = createRequestSaga(
  GET_SHAMPOO_LIST,
  shampooAPI.getShampooList,
);

export const postUserConditionSaga = createRequestSaga(
  PUT_USER_CONDITIONS,
  shampooAPI.postUserConditions,
);

export const postTemporaryUserConditionSaga = createRequestSaga(
  POST_TEMPORARY_USER_CONDITIONS,
  shampooAPI.postTemporaryUserConditions,
);

export const postTemporaryUserAuthSaga = createRequestSaga(
  POST_TEMPORARY_USER_AUTH,
  shampooAPI.postTemporaryUserAuth,
);

export const postShampooResultSaga = createRequestSaga(
  POST_SHAMPOO_RESULT,
  shampooAPI.postShampooResult,
);
export const getShampooIngredientsSaga = createRequestSaga(
  GET_SHAMPOO_INGREDIENTS,
  shampooAPI.getShampooIngredients,
);
export const postShampooRegisterSaga = createRequestSaga(
  POST_SHAMPOO_REGISTER,
  shampooAPI.postShampooRegister,
);
export const getShampooHistoriesSaga = createRequestSaga(
  GET_SHAMPOO_HISTORIES,
  shampooAPI.getShampooHistories,
);
export const getTopRankedShampooListSaga = createRequestSaga(
  GET_TOP_RANKED_SHAMPOO_LIST,
  shampooAPI.getTopRankedShampooList,
);

export function* shampooSaga() {
  yield takeLatest(GET_SHAMPOO_LIST, getShampooListSaga);
  yield takeLatest(PUT_USER_CONDITIONS, postUserConditionSaga);
  yield takeLatest(
    POST_TEMPORARY_USER_CONDITIONS,
    postTemporaryUserConditionSaga,
  );
  yield takeLatest(POST_TEMPORARY_USER_AUTH, postTemporaryUserAuthSaga);
  yield takeLatest(POST_SHAMPOO_RESULT, postShampooResultSaga);
  yield takeLatest(GET_SHAMPOO_INGREDIENTS, getShampooIngredientsSaga);
  yield takeLatest(POST_SHAMPOO_REGISTER, postShampooRegisterSaga);
  yield takeLatest(GET_SHAMPOO_HISTORIES, getShampooHistoriesSaga);

  yield takeLatest(PUT_USER_CONDITIONS_SUCCESS, handlePutUserConditionsSuccess);
  yield takeLatest(
    POST_TEMPORARY_USER_CONDITIONS_SUCCESS,
    handlePostTemporaryUserConditionsSuccess,
  );
  yield takeLatest(
    POST_TEMPORARY_USER_AUTH_SUCCESS,
    handlePostTemporaryUserAuthSuccess,
  );
  yield takeLatest(POST_SHAMPOO_RESULT_SUCCESS, handlePostShampooResultSuccess);
  yield takeLatest(GET_TOP_RANKED_SHAMPOO_LIST, getTopRankedShampooListSaga);
  yield takeLatest(
    GET_TOP_RANKED_SHAMPOO_LIST_SUCCESS,
    handleGetTopRankedShampooListSuccess,
  );
}

//====================== Initial State ======================//
const initialState = {
  shampooList: {
    response: null,
    error: null,
  },
  searchQuery: '',
  selectedShampooId: null,
  shampooResult: { response: null, error: null },
  ingredients: { response: null, error: null },
  userConditions: {
    gender: null,
    age_group: null,
    scalp_type: null,
    hair_loss_type: null,
    hair_loss_level: null,
    hair_loss_family_history: {
      parents: 'NO',
      grandparents: 'NO',
      maternal_grandparents: 'NO',
      none: 'NO',
    },
    scalp_issue: [],
    shampoo_preference: [],
    hair_preference: null,
    lifestyle: {
      wash_hair_cycle: null,
      dyeing: null,
      perm: null,
    },
    optional_lifestyle: {
      styling_product: null,
      night_shampoo: null,
      treatment_product: null,
      scalp_nutrition: null,
      pregnant: null,
      smoking: null,
      drinking: null,
      coffee: null,
      sleep_time: null,
      outdoor_time: null,
      stress: null,
      drug: null,
    },
  },
  putUserConditionsResult: { response: null, error: null },
  postTemporaryUserConditionsResult: { response: null, error: null },
  postTemporaryUserAuthResult: { response: null, error: null },
  registerForm: {
    selection: '',
    textInput: '',
    phoneNumber: '',
  },
  registerResult: { response: null, error: null },
  histories: { response: null, error: null },
  topRankedShampooList: {
    response: null,
    error: null,
  },
  searchType: null,
  resultType: 'withScalp', // 'normal' or 'withScalp'
};

export default handleActions(
  {
    [GET_SHAMPOO_LIST_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      // id를 키값으로 하는 객체 형태로 저장
      shampooList: {
        response: result.productList.reduce((acc, item) => {
          return { ...acc, [item['id']]: item };
        }, {}),
        error: initialState.shampooList.error,
      },
    }),

    [GET_SHAMPOO_LIST_FAILURE]: (state, { payload: error }) => ({
      ...state,
      shampooList: {
        response: initialState.shampooList.response,
        error: error,
      },
    }),
    [POST_SHAMPOO_RESULT]: (state) => ({
      ...state,
      shampooResult: initialState.shampooResult,
    }),
    [POST_SHAMPOO_RESULT_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      shampooResult: {
        response: result,
        error: initialState.shampooResult.error,
      },
      //새로운 샴푸 분석결과가 생기면 분석히스토리를 초기화해서 메인화면 접속시 다시 페치하도록 함
      histories: {
        response: initialState.histories.response,
        error: initialState.histories.error,
      },
    }),
    [POST_SHAMPOO_RESULT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      shampooResult: {
        response: initialState.shampooResult.response,
        error: error,
      },
    }),
    [GET_SHAMPOO_INGREDIENTS]: (state) => ({
      ...state,
      ingredients: initialState.ingredients,
    }),
    [GET_SHAMPOO_INGREDIENTS_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      ingredients: {
        response: result,
        error: initialState.ingredients.error,
      },
    }),
    [GET_SHAMPOO_INGREDIENTS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      ingredients: {
        response: initialState.ingredients.response,
        error: error,
      },
    }),
    [CHANGE_SEARCH_QUERY]: (state, { payload: value }) => ({
      ...state,
      searchQuery: value,
    }),
    [SET_SELECTED_SHAMPOO_ID]: (state, { payload: shampooId }) => ({
      ...state,
      selectedShampooId: shampooId,
    }),
    [SET_SEARCH_TYPE]: (state, { payload: type }) =>
      produce(state, (draft) => {
        draft.searchType = type;
      }),
    [SET_RESULT_TYPE]: (state, { payload: type }) =>
      produce(state, (draft) => {
        draft.resultType = type;
      }),
    [PUT_USER_CONDITIONS_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      putUserConditionsResult: {
        response: result.user,
        error: initialState.putUserConditionsResult.error,
      },
    }),
    [PUT_USER_CONDITIONS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      putUserConditionsResult: {
        response: initialState.putUserConditionsResult.response,
        error: error,
      },
    }),
    [POST_TEMPORARY_USER_CONDITIONS_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      postTemporaryUserConditionsResult: {
        response: result,
        error: initialState.postTemporaryUserConditionsResult.error,
      },
    }),
    [POST_TEMPORARY_USER_CONDITIONS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      putTemporaryUserConditionsResult: {
        response: initialState.putTemporaryUserConditionsResult.response,
        error: error,
      },
    }),
    [POST_TEMPORARY_USER_AUTH_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      postTemporaryUserAuthResult: {
        response: result,
        error: initialState.postTemporaryUserAuthResult.error,
      },
    }),
    [POST_TEMPORARY_USER_AUTH_FAILURE]: (state, { payload: error }) => ({
      ...state,
      postTemporaryUserAuthResult: {
        response: initialState.postTemporaryUserAuthResult.response,
        error: error,
      },
    }),
    [CHANGE_USER_CONDITION]: (state, { payload: { key, childKey, value } }) => {
      if (key === 'scalp_issue') {
        const foundIndex = state.userConditions.scalp_issue.findIndex(
          (elem) => elem.issue === childKey,
        );

        if (childKey === 'NONE') {
          if (foundIndex >= 0) {
            //토글링
            return produce(state, (draft) => {
              draft.userConditions[key] = [];
            });
          }
          //추가
          return produce(state, (draft) => {
            draft.userConditions[key] = [{ issue: childKey }];
          });
        }

        if (state.userConditions.scalp_issue[0]?.issue === 'NONE') {
          return produce(state, (draft) => {
            draft.userConditions[key] = [{ issue: childKey, level: value }];
          });
        }

        if (foundIndex >= 0) {
          if (value === null) {
            //issue & level 토글링
            const newArr = state.userConditions.scalp_issue.filter(
              (elem) => elem.issue !== childKey,
            );
            return produce(state, (draft) => {
              draft.userConditions[key] = newArr;
            });
          } else {
            // level만 토글링
            if (value === state.userConditions[key][foundIndex].level) {
              return produce(state, (draft) => {
                draft.userConditions[key][foundIndex] = {
                  issue: childKey,
                  level: null,
                };
              });
            }
            //level만 업데이트
            return produce(state, (draft) => {
              draft.userConditions[key][foundIndex].level = value;
            });
          }
        }

        //최대 3개까지만 선택 가능
        if (state.userConditions.scalp_issue.length === 3) {
          return produce(state, (draft) => {
            draft.userConditions[key] = state.userConditions[key];
          });
        }

        //issue & level 추가
        const newArr = [
          ...state.userConditions.scalp_issue,
          { issue: childKey, level: value },
        ];
        return produce(state, (draft) => {
          draft.userConditions[key] = newArr;
        });
      }

      if (key === 'shampoo_preference') {
        if (state.userConditions[key].includes(childKey)) {
          return produce(state, (draft) => {
            draft.userConditions[key] = draft.userConditions[key].filter(
              (elem) => elem !== childKey,
            );
          });
        }
        //최대 2개까지만 선택 가능
        if (state.userConditions[key].length === 2) {
          return produce(state, (draft) => {
            draft.userConditions[key] = state.userConditions[key];
          });
        }
        //추가
        return produce(state, (draft) => {
          draft.userConditions[key] = [...state.userConditions[key], childKey];
        });
      }

      if (childKey) {
        return produce(state, (draft) => {
          draft.userConditions[key][childKey] = value;
        });
      }

      return produce(state, (draft) => {
        draft.userConditions[key] = value;
      });
    },
    [INIT_USER_CONDITION]: (state, { payload: { key, childKey } }) => {
      if (childKey) {
        return produce(state, (draft) => {
          draft.userConditions[key][childKey] =
            initialState.userConditions[key][childKey];
        });
      }
      return produce(state, (draft) => {
        draft.userConditions[key] = initialState.userConditions[key];
      });
    },
    [INIT_USER_CONDITIONS]: (state) => ({
      ...state,
      userConditions: initialState.userConditions,
      putUserConditionsResult: initialState.putUserConditionsResult,
    }),
    [CHANGE_REGISTER_FORM]: (state, { payload: { key, value } }) => {
      return produce(state, (draft) => {
        draft.registerForm[key] = value;
      });
    },
    [INIT_REGISTER_FORM]: (state) => ({
      ...state,
      registerForm: initialState.registerForm,
      registerResult: initialState.registerResult,
    }),
    [POST_SHAMPOO_REGISTER_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      registerResult: {
        response: result,
        error: initialState.registerResult.error,
      },
    }),
    [POST_SHAMPOO_REGISTER_FAILURE]: (state, { payload: error }) => ({
      ...state,
      registerResult: {
        response: initialState.registerResult.response,
        error: error,
      },
    }),
    [GET_SHAMPOO_HISTORIES_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      histories: {
        response: result.histories,
        error: initialState.histories.error,
      },
    }),
    [GET_SHAMPOO_HISTORIES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      histories: {
        response: initialState.histories.response,
        error: error,
      },
    }),
    [SET_SHAMPOO_RESULT_FROM_HISTORY]: (state, { payload: result }) => ({
      ...state,
      shampooResult: {
        response: result,
        error: initialState.histories.response,
      },
    }),

    [GET_TOP_RANKED_SHAMPOO_LIST]: (state) => ({
      ...state,
      topRankedShampooList: initialState.topRankedShampooList,
    }),
    [GET_TOP_RANKED_SHAMPOO_LIST_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      topRankedShampooList: {
        response: result.ranks,
        error: initialState.topRankedShampooList.error,
      },
    }),
    [GET_TOP_RANKED_SHAMPOO_LIST_FAILURE]: (state, { payload: error }) => ({
      ...state,
      topRankedShampooList: {
        response: initialState.topRankedShampooList.response,
        error: error,
      },
    }),
  },
  initialState,
);
